<template>
    <div>
        <div class="row">
            <div class="col mt-lg-4">
                <h3>3. {{ $t('pax.suggestions_pax') }}</h3>
            </div>
        </div>
        <div v-if="processing">
            <LoadingSpinner class="col-12" />
        </div>

        <div v-else class="mt-lg-4">
            <!-- <div class="stallionGrade" v-for="stallion in stallions_suggestion" :key="stallion.horse_id" :class="callColorGrade(stallion.horse_id)">
                <div class="row no-gutters align-items-center" @click="showCompatibilite">
                    <div class="col-5">
                        <div class="stallionName">{{ stallion.horse_nom }}</div>
                    </div>
                    <div class="col-7 text-center">
                        <span class="bullet" v-for="critere in criteres" :class="getColorBullets(stallion.horse_id, recap, criteres, critere.criteres_id)[0]" :key="critere.criteres_id"><font-awesome-icon :icon="['fas', 'circle']"/></span>
                    </div>
                </div>
            </div> -->

            <div class="stallionGradeV2" v-for="stallion in stallions_suggestion" :key="stallion.horse_id">
                <div class="row align-items-center" @click="showCompatibilite">
                    <div class="col">
                        <div :class="getGlobalColor(callColorGrade(stallion.horse_id), colorGeneticIndicator(stallion.horse_id))" class="stallionName">{{ stallion.horse_nom }}</div>
                    </div>
                    <div class="col-auto">
                        <div :class="colorGeneticIndicator(stallion.horse_id)"  class="icon_pax"><font-awesome-icon :icon="['fal', 'venus-mars']"/></div>
                    </div>
                    <div class="col-auto">
                        <div :class="callColorGrade(stallion.horse_id)" class="icon_pax"><font-awesome-icon :icon="['fal', 'puzzle']"/></div>
                    </div>
                </div>
            </div>

            <div class="text-center mt-3">
                <button class="btn btn-pax mr-2" :disabled="processing" @click="relancerSuggestion">
                    <font-awesome-icon :icon="['fal', 'redo']" /> {{ $t('pax.relancer_suggestion') }}
                </button>
            </div>
            <div class="text-right">
                <button class="btn btn-primary btn-next" @click="showCompatibilite">
                   {{ $t('pax.comparer_jusqua_3_etalons') }} <font-awesome-icon :icon="['fal', 'long-arrow-right']" />
                </button>
            </div>
        </div>

        <b-modal dialog-class="modal-pax" ref="modal" hide-footer id="paxModalSelection">
            <template v-slot:modal-title>
                {{ $t("pax.comparer_jusqua_3_etalons") }}
            </template>

            <div v-for="(stallion, index) in stallions_selected" class="form-group" :key="'stallion_'+index">
                <label for="season">{{ $t('pax.stallion') }} {{ index+1 }}</label>
                <e-select
                    :value="stallions_selected[index]"
                    @input="$set(stallions_selected, index, $event)"
                    track-by="horse_id"
                    label="horse_nom"
                    :placeholder="$t('pax.selectionner_un_stallion')"
                    :options="getOptionsForSlot(index)"
                    :allow-empty="false"
                    :show-labels="false"
                    :sortable="false"
                    :searchable="false"
                >
                    <template slot="singleLabel" slot-scope="{ option }">
                        <!-- div class="stallionGrade" :key="option.horse_id" :class="callColorGrade(option.horse_id)">
                            <div class="row no-gutters align-items-center" >
                                <div class="col-5">
                                    <div class="stallionName">{{ option.horse_nom }}</div>
                                </div>
                                <div class="col-7 text-center">
                                    <span class="bullet" v-for="critere in criteres" :class="getColorBullets(option.horse_id, recap, criteres, critere.criteres_id)[0]" :key="critere.criteres_id"><font-awesome-icon :icon="['fas', 'circle']"/></span>
                                </div>
                            </div>
                        </div> -->
                        <div class="stallionGradeV2" :key="option.horse_id">
                            <div class="row align-items-center" @click="showCompatibilite">
                                <div class="col">
                                    <div :class="getGlobalColor(callColorGrade(option.horse_id), colorGeneticIndicator(option.horse_id))"  class="stallionName">{{ option.horse_nom }}</div>
                                </div>
                                <div class="col-auto">
                                    <div :class="callColorGrade(option.horse_id)" class="icon_pax"><font-awesome-icon :icon="['fal', 'venus-mars']"/></div>
                                </div>
                                <div class="col-auto">
                                    <div :class="colorGeneticIndicator(option.horse_id)" class="icon_pax">
                                        <font-awesome-icon :icon="['fal', 'puzzle']"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                        <!-- <div class="stallionGrade" :key="option.horse_id" :class="callColorGrade(option.horse_id)">
                            <div class="row no-gutters align-items-center" >
                                <div class="col-5">
                                    <div class="stallionName">{{ option.horse_nom }}</div>
                                </div>
                                <div class="col-7 text-center">
                                    <span class="bullet" v-for="critere in criteres" :class="getColorBullets(option.horse_id, recap, criteres, critere.criteres_id)[0]" :key="critere.criteres_id"><font-awesome-icon :icon="['fas', 'circle']"/></span>
                                </div>
                            </div>
                        </div> -->
                        <div class="stallionGradeV2" :key="option.horse_id">
                            <div class="row align-items-center" @click="showCompatibilite">
                                <div class="col">
                                    <div :class="getGlobalColor(callColorGrade(option.horse_id), colorGeneticIndicator(option.horse_id))"  class="stallionName">{{ option.horse_nom }}</div>
                                </div>
                                <div class="col-auto">
                                    <div :class="callColorGrade(option.horse_id)" class="icon_pax"><font-awesome-icon :icon="['fal', 'venus-mars']"/></div>
                                </div>
                                <div class="col-auto">
                                    <div :class="colorGeneticIndicator(option.horse_id)" class="icon_pax">
                                        <font-awesome-icon :icon="['fal', 'puzzle']"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                </e-select>
            </div>

            <div class="text-center">
                <button class="btn btn-pax" @click="sendStallionsSelected">{{ $t('pax.comparer') }}</button>
            </div>
        </b-modal>
    </div>
</template>

<script type="text/javascript">
    import PaxMixin from "@/mixins/Pax.js"
    import Navigation from "@/mixins/Navigation.js"

    export default {
        name: 'PaxSuggestionResult',
        mixins: [PaxMixin, Navigation],
        props: {
            criteres: {
                type: Array,
                default: () => ( [] )
            },
            mare: {
                type: Object,
                default: () => ( null )
            }
        },
        data () {
            return {
                stallions_suggestion: [],
                stallions_selected: [null, null, null],
                weighted_pool: [],
                recap: [],
                processing: false,
                genetic_indicators: [],
                genetic_loading: false,
                compat_loading: false
            }
        },
        mounted() {
            this.init_component()
        },
        methods: {
            init_component() {
                this.calculSuggestion()
            },

            /**
             * Retourne la liste des étalons disponibles pour un slot du modal,
             * en excluant ceux déjà sélectionnés dans les autres slots.
             * @param {number} index - Index du slot (0, 1 ou 2)
             * @returns {Array}
             */
            getOptionsForSlot(index) {
                const otherIds = this.stallions_selected
                    .filter((s, i) => i !== index && s && s.horse_id)
                    .map(s => s.horse_id)
                return this.stallions_suggestion.filter(s => !otherIds.includes(s.horse_id))
            },

            callColorGrade(stallion_id) {
                if(this.compat_loading) return 'genetic-loading'
                return this.colorGrade(stallion_id, this.recap, this.criteres)
            },

            async calculSuggestion() {
                this.processing = true

                const country = this.getConfig('country')

                const all_stallions = await this.getStallions()
                const stallions = all_stallions.filter(stallion => {
                    return stallion.horse_pays.indexOf(parseInt(country.id)) > -1 && !stallion.categorie.includes('COLLECTION')
                })

                this.compat_loading = true
                this.recap = await this.paxCalculCompatiblite(stallions, this.criteres)
                this.compat_loading = false

                // Score de compatibilité par couleur
                const compat_color_score = { dark_green: 3, green: 2, yellow: 1 }

                // Attribuer une couleur et un score compat à chaque étalon
                const stallions_with_color = stallions.map(stallion => {
                    const color = this.colorGrade(stallion.horse_id, this.recap, this.criteres)
                    return { stallion, color, compat_score: compat_color_score[color] || 0 }
                })

                // Pool principal : dark_green + green (max 20)
                const green_pool = stallions_with_color.filter(s => s.color === 'dark_green' || s.color === 'green')
                let candidates = [...green_pool]

                // Si moins de 5 verts, compléter avec les meilleurs yellow
                if (candidates.length < 5) {
                    const notation = await this.getPaxColor(this.recap, this.criteres)
                    const yellow_pool = stallions_with_color
                        .filter(s => s.color === 'yellow')
                        .sort((a, b) => (notation[b.stallion.horse_id] || 0) - (notation[a.stallion.horse_id] || 0))
                    const needed = 20 - candidates.length
                    candidates = candidates.concat(yellow_pool.slice(0, needed))
                } else {
                    candidates = candidates.slice(0, 20)
                }

                // Récupérer l'indicateur génétique sur les candidats
                const genetic_color_score = { dark_green: 3, green: 2, yellow: 1, red: -1 }
                let genetic_indicators_candidates = {}
                if (this.mare && this.mare.horse_id && candidates.length > 0) {
                    const ids = candidates.map(c => c.stallion.horse_id).join(',')
                    genetic_indicators_candidates = await this.getGeneticIndicator(this.mare.horse_id, ids) || {}
                }

                // Score combiné (0-6) + plancher à 1 pour garantir une probabilité non nulle
                const weighted_pool = candidates.map(c => {
                    const indicator = genetic_indicators_candidates[c.stallion.horse_id]
                    const genetic_bonus = indicator ? (genetic_color_score[indicator.genetic_indicator_color] || 0) : 0
                    const combined = Math.max(0, c.compat_score + genetic_bonus)
                    return { stallion: c.stallion, weight: combined + 1 }
                })

                // Tirage aléatoire pondéré sans remise → 5 étalons suggérés
                this.weighted_pool = weighted_pool
                this.stallions_suggestion = this.weightedRandomDraw(weighted_pool, 5).map(w => w.stallion)

                // Indicateur génétique final pour la colorisation des tuiles
                this.calculGeneticIndicator()
                this.processing = false
            },

            relancerSuggestion() {
                if (this.weighted_pool.length === 0) return
                this.stallions_selected = [null, null, null]
                this.stallions_suggestion = this.weightedRandomDraw(this.weighted_pool, 5).map(w => w.stallion)
                this.calculGeneticIndicator()
            },

            /**
             * Tirage aléatoire pondéré sans remise.
             * @param {Array} pool - Tableau d'objets { stallion, weight }
             * @param {number} count - Nombre d'éléments à tirer
             * @returns {Array}
             */
            weightedRandomDraw(pool, count) {
                const result = []
                const remaining = [...pool]
                for (let i = 0; i < Math.min(count, remaining.length); i++) {
                    const totalWeight = remaining.reduce((sum, s) => sum + s.weight, 0)
                    let rand = Math.random() * totalWeight
                    let picked = remaining.length - 1
                    for (let j = 0; j < remaining.length; j++) {
                        rand -= remaining[j].weight
                        if (rand <= 0) { picked = j; break }
                    }
                    result.push(remaining[picked])
                    remaining.splice(picked, 1)
                }
                return result
            },

            async showCompatibilite() {
                if(this.stallions_suggestion.length > 3) {
                    this.$refs.modal.show()
                    return false
                }
                this.$emit('update:step_label', "comparaison_V")
                this.$emit('update:stallions_comparaison', this.stallions_suggestion)
            },

            sendStallionsSelected() {
                this.$refs.modal.hide()
                this.$emit('update:step_label', "comparaison_V")
                this.$emit('update:stallions_comparaison', this.stallions_selected)
            },

            async calculGeneticIndicator() {
                const stallions_ids = this.stallions_suggestion.map(stallion => stallion.horse_id)
                if(!this.mare || stallions_ids.length == 0) return false
                this.genetic_loading = true
                this.genetic_indicators = await this.getGeneticIndicator(this.mare.horse_id, stallions_ids.join(','))
                this.genetic_loading = false
            },

            colorGeneticIndicator(stallion_id) {
                if(this.genetic_loading) return 'genetic-loading'
                return Object.prototype.hasOwnProperty.call(this.genetic_indicators, stallion_id) ? this.genetic_indicators[stallion_id].genetic_indicator_color : ''
            }
        },
        components: {
            LoadingSpinner : () => import('GroomyRoot/components/Logos/LoadingSpinner_35')
        },
        watch: {
            'criteres': {
                deep: true,
                handler(val){
                    this.calculSuggestion()
                }
            },

        }
    }

</script>